import { alpha, type Components, type Theme } from '@mui/material';
declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        mustard: true;
        greyScale: true;
        neutral: true;
    }
}

export const componentsTheme: Components<Theme> = {
    MuiAlert: {
        styleOverrides: {
            action: {
                // Qui puoi inserire le personalizzazioni
                padding:   "4px 0px 0px 4px",
                display:"flex",
                alignItems:"center"
              
            },
        },
    },
    MuiCard: {
        styleOverrides: {
            root: ({ /*theme*/ }) => ({
                "--tw-shadow": "0 1px 2px 0 rgb(0 0 0 / 0.3)",
                "--tw-shadow-colored": "0 1px 2px 0 var(--tw-shadow-color)",
                boxShadow:
                    "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
                borderRadius: "0.375rem", // Equivalente a rounded-md in Tailwind
                /* padding: `${theme.spacing(2)} ${theme.spacing(4)}`, // Padding corretto */
            }),
        },
    },
    // Personalizzazione InputLabel
    MuiInputLabel: {
        styleOverrides: {
            root: ({ theme }) => ({
                fontWeight: 400,
                '& .MuiInputLabel-asterisk, & .MuiFormHelperText-error'
                    : {
                    color: theme.palette.error.main,
                }
            }),
        },
    },
    //Inputfield
    MuiInputBase: {
        styleOverrides: {
            root: ({ theme }) => ({

                borderRadius: '8px',
                boxSizing: 'border-box', // Mantiene il padding corretto
                boxShadow: `inset 0 0 0 1px ${theme.palette.greyScale.dark}`, // Bordo interno
                'label + &': {
                    marginTop: "20px",
                },
                '&:hover': {
                    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`
                },
                '&.Mui-focused': {
                    boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`
                },
                '&.Mui-disabled': {
                    boxShadow: `inset 0 0 0 1px ${theme.palette.greyScale.main}`,
                    backgroundColor: theme.palette.greyScale.light,
                    cursor: 'not-allowed',
                    opacity: 0.6,
                },
                '&.Mui-error': {
                    boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}`,
                },
                '& textarea': {
                    minHeight: "28px",
                    padding: "10px",
                    resize: 'vertical',
                },
                '& input': {
                    minHeight: "28px",
                    padding: "10px",
                },
                '& .input-icon': {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    height: "28px",
                    width: "36px",
                    borderLeft: `0.5px solid ${theme.palette.greyScale.main}`,
                },
                '& .MuiInputAdornment-root': {
                    margin: 0
                },

            })
        }

    },
    MuiFormControl: {
        styleOverrides: {
            root: ({ theme }) => ({
                maxHeight: '30vh',
                minHeight: '52px', //Almeno non c'è lo scroll
                overflowY: "auto",
            })
        }
    },

    //Selectfield
    MuiSelect: {
        styleOverrides: {
            root: ({ theme }) => ({
                minHeight: "48px",
                borderRadius: '8px',
                boxSizing: 'border-box',

                boxShadow: `inset 0 0 0 1px ${theme.palette.greyScale.dark}`, // Bordo interno
                'label + &': {
                    marginTop: "20px",
                },
                '&:hover': {
                    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
                },
                '&.Mui-focused': {
                    boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`,
                },
                '&.Mui-disabled': {
                    boxShadow: `inset 0 0 0 1px ${theme.palette.greyScale.main}`,
                    cursor: 'not-allowed',
                    opacity: 0.6,
                },
                '&.Mui-error': {
                    boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}`,
                },

                // Stili specifici per eliminare il bordo inferiore indesiderato
                '&:before, &:after': {
                    display: 'none', // Rimuove eventuali pseudo-elementi che generano bordi
                },

                '& .MuiSelect-select': {
                    minHeight: "28px",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',    // occupa al massimo il 100% del parent
                },



                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important', // Rimuove il bordo predefinito di Select
                },

                '& .MuiSelect-icon': {
                    color: theme.palette.greyScale.dark,
                },
            }),
            select: {
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                hyphens: 'auto',
            },
        },
    },
    MuiMenu: {
        styleOverrides: {

            paper: ({ theme }) => ({
                border: `1px solid  ${theme.palette.primary.main}`,
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                borderRadius: '8px',
                marginTop: '4px',
            }),
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                display: 'block',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                borderRadius: '0px',
                height: 'fit-content',
                lineHeight: '1.4',
            },
        }
    },

    //Tabella
    MuiTableCell: {
        styleOverrides: {
            root: {
                border: '1px solid #e8e8e8', // Aggiungi il bordo
            },
            head: ({ theme }) => ({
                backgroundColor: alpha(theme.palette.secondary.main, 1),
                color: 'white',
                fontWeight: 700,
                borderColor: 'white'
            }),
        },
    },
    MuiTableRow: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&:nth-of-type(even)': {
                    backgroundColor:
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]    // colore chiaro in light mode
                            : theme.palette.grey[800],   // colore scuro in dark mode
                },
            }),
        },
    },

    MuiButton: {
        styleOverrides: {
            root: {
                boxShadow: "none",
                display: "flex",
                gap: "8px",
                borderRadius: '50px',
                lineHeight: "20px",
                padding: "10px 0px",
                height: "48px",
                '&:hover': {
                    boxShadow: `none`,
                },
                "&.MuiButton-contained": {
                }
            },

        }
    }
}